import React from "react";

const PersonSVG = ({ width = 20, height = 20, fill = "#044225", ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={fill}
            viewBox="0 0 30 23"
            {...props}
        >
            <path d="M15.5 0C20.4889 0 24.5417 4.03393 24.5417 9C24.5417 13.9661 20.4891 18 15.5 18C10.5109 18 6.45833 13.9661 6.45833 9C6.45833 4.03393 10.5109 0 15.5 0ZM15.5 2.57143C11.935 2.57143 9.04167 5.45143 9.04167 9C9.04167 12.5486 11.935 15.4286 15.5 15.4286C19.065 15.4286 21.9583 12.5486 21.9583 9C21.9583 5.45143 19.065 2.57143 15.5 2.57143ZM21.9583 20.5714C26.9522 20.5714 31 24.6005 31 29.5714V32.1429C31 33.1666 30.5915 34.147 29.8649 34.8702C29.1384 35.5934 28.1535 36 27.125 36H3.875C2.8465 36 1.86161 35.5934 1.13505 34.8702C0.408498 34.147 0 33.1666 0 32.1429V29.5714C0 24.6005 4.04777 20.5714 9.04167 20.5714H21.9583ZM21.9583 23.1429H9.04167C5.47505 23.1429 2.58333 26.0213 2.58333 29.5714V32.1429C2.58333 32.4836 2.71896 32.8114 2.96114 33.0525C3.20333 33.2936 3.5327 33.4286 3.87498 33.4286H27.125C27.4673 33.4286 27.7967 33.2936 28.0388 33.0525C28.281 32.8114 28.4166 32.4836 28.4166 32.1429V29.5714C28.4166 26.0213 25.5249 23.1429 21.9583 23.1429Z" fill={fill}/>
        </svg>
    );
};

export default PersonSVG; 